import type { ComponentPropsWithoutRef, ReactNode } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";

export interface ActionButtonsProps extends ComponentPropsWithoutRef<"nav"> {
  children: ReactNode;
  className?: string;
}

export const ActionButtons = ({
  children,
  className,
  ...rest
}: ActionButtonsProps) => (
  <nav
    className={classNames("flex flex-col items-center gap-4", className)}
    {...rest}
  >
    {children}
  </nav>
);
